import {AxiosError, AxiosResponse, AxiosStatic} from "axios";

export default (http: AxiosStatic, resource = '/api/mystudychoice/mystudychoice') => ({
    getActivity(locale: string ): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .get(`${resource}/events/${locale}`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    },
    getFavourite(language: string, study_code: string ): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .get(`${resource}/favoritestudy/${language}/${study_code}`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    },
    setFavourite(language: string , study_code: string): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .post(`${resource}/favoritestudy/${language}/${study_code}`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    },
    deleteFavourite(favorite_id: number): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .delete(`${resource}/favoritestudy/${favorite_id}`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    },
    getAllStudiesWithFavorites(language: string): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .get(`${resource}/studieswithfavorites/${language}`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    }
})


